var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewConfirmedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 41,
    rx: 12.5,
    fill: "white",
    stroke: "#E3E3E3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9836 27.4967C18.7222 27.4967 19.3218 28.1048 19.3218 28.8538C19.3218 29.6028 18.7222 30.2109 17.9836 30.2109C17.245 30.2109 16.6453 29.6028 16.6453 28.8538C16.6453 28.1048 17.245 27.4967 17.9836 27.4967ZM27.7975 27.4967C28.5361 27.4967 29.1358 28.1048 29.1358 28.8538C29.1358 29.6028 28.5361 30.2109 27.7975 30.2109C27.0589 30.2109 26.4592 29.6028 26.4592 28.8538C26.4592 28.1048 27.0589 27.4967 27.7975 27.4967ZM14.5709 14.8715L13.949 11.9256C13.8607 11.5086 13.4977 11.2109 13.0765 11.2109H10.4C9.9075 11.2109 9.50781 11.6163 9.50781 12.1157C9.50781 12.6151 9.9075 13.0204 10.4 13.0204H12.3556L14.7296 24.2564C14.9054 25.0907 15.6325 25.6869 16.4739 25.6869H29.2962C30.1474 25.6869 30.8791 25.078 31.0459 24.232L32.4734 16.9965C32.5778 16.4644 32.4421 15.9127 32.1022 15.4928C31.7623 15.0739 31.2546 14.8304 30.7193 14.8322L14.5709 14.8715ZM30.7238 16.642L14.9537 16.6802L16.474 23.8774H29.2963L30.7238 16.6419V16.642Z",
    fill: "#ffbb00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewConfirmedIcon);
export default __webpack_public_path__ + "static/media/new-confirmed-icon.6c2c59135c327e3ca1844e3df4d1fd54.svg";
export { ForwardRef as ReactComponent };